import React from 'react';
import * as Ajax from '../services/index'
import './index.css'

class Photo extends React.Component{
    constructor(props){
        super(props);
        this.state={
            list: [],
            isDelete:false,
        };
        document.getElementsByTagName("title")[0].innerText = 'PHOTO'
    }
    componentDidMount(){
        // let query = this.props.history.location.query ||{};
        let search = this.props.history.location.search ||'';
        let query = {};
        if(search){
            search = search.slice(1)||'';
            let arr = search.split('&');
            arr.forEach(item=>{
                let arr1 = item.split('=');
                query[arr1[0]] = arr1[1]
            })
        }
        console.log('----query',query)
        this.getInitData(query)
    }
    render(){
        let {list} = this.state;
        return <div className="photo">
            {list && list.length>0?<div className="photo_top">
                <div>长按图片保存至相册</div>
                <div>Long-press to save image</div>
                <div className="photo_icon"></div>
            </div>:
            <div className="photo_top">
                <div>照片未上传完成，请稍后重试</div>
                <div>Photo upload not finished, </div>
                <div>please refresh this page in a few seconds</div>
            </div>
            }
            <div className="photo_list">
                {list.map((item,index)=>{
                    return <div key={item.photoId} className="photo_list_item">
                        <img src={item.publicUrl} alt="照片"/>
                    </div>
                })}
            </div>
        </div>
    }

    getInitData (query) {
        Ajax.getPhoto({businessSku: query.sku}).then((res)=>{
            this.setState({
                list: res.list || res || [],
                isDelete: res.isDelete || false
            })
        })
    }
}

export default Photo